import { render, staticRenderFns } from "./ExpenseManagmentProviders.vue?vue&type=template&id=621b0d5c&scoped=true"
import script from "./ExpenseManagmentProviders.vue?vue&type=script&lang=js"
export * from "./ExpenseManagmentProviders.vue?vue&type=script&lang=js"
import style0 from "./ExpenseManagmentProviders.vue?vue&type=style&index=0&id=621b0d5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621b0d5c",
  null
  
)

export default component.exports